import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { editOrganization } from '../../../../../settings/actions/organization';
import { holdMusicActions } from '../actions/holdMusicActions';
import HoldMusicModal from '../components/HoldMusicModal';
export const { holdMusicGetAll, holdMusicUpload, holdMusicReset, holdMusicShowModal, holdMusicHideModal, holdMusicHoldingForSplitingClose, } = holdMusicActions;
const mapStateToProps = (state, ownProps) => {
    return {
        allAudios: state.holdMusic.allAudios,
        meta: state.holdMusic.meta,
        jobIds: state.holdMusic.jobIds,
        orgId: state.settings.organization.organization.id,
        selectedAudio: state.holdMusic.selectedAudio,
        isNewAudioOpen: state.holdMusic.ui.isNewAudioOpen,
        isHoldModalOpen: state.holdMusic.ui.isHoldModalOpen,
        isHoldingOpen: state.holdMusic.ui.isHoldingOpen,
        labelError: ownProps.labelError !== undefined && ownProps.labelError !== ''
            ? ownProps.labelError
            : null,
        className: ownProps.className !== undefined && ownProps.className !== ''
            ? ownProps.className
            : null,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        audioGetAllHoldMusic: bindActionToPromise(dispatch, holdMusicGetAll),
        audioReset: () => dispatch(holdMusicReset()),
        onSelectedCallback: (payload) => ownProps.onSelectedCallback(payload),
        audioHideModal: () => dispatch(holdMusicHideModal()),
        audioShowModal: () => dispatch(holdMusicShowModal()),
        editOrganization: (id, payload) => dispatch(editOrganization(id, payload)),
        holdMusicHoldingForSplitingClose: () => dispatch(holdMusicHoldingForSplitingClose()),
    };
};
const mapOwnProps = (state, dispatch, own) => {
    var _a, _b;
    return (Object.assign(Object.assign(Object.assign(Object.assign({}, state), dispatch), own), { 
        /*
         * For compatibility with the new phone settings page
         * we need to be able to pass our own onClose & isOpen.
         */
        onClose: (_a = own.onClose) !== null && _a !== void 0 ? _a : dispatch.audioHideModal, isOpen: (_b = own.isOpen) !== null && _b !== void 0 ? _b : state.isHoldModalOpen }));
};
export default connect(mapStateToProps, mapDispatchToProps, mapOwnProps)(HoldMusicModal);
